(() => {
  const initAppPage = (root) => {
    if (!root || root.dataset.appInitialized === 'true') return;
    root.dataset.appInitialized = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-app-world]'));
    const panels = Array.from(root.querySelectorAll('[data-app-panel]'));

    const activateWorld = (world) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.appWorld === world;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });

      panels.forEach((panel) => {
        const active = panel.dataset.appPanel === world;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateWorld(tab.dataset.appWorld));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const offset = event.key === 'ArrowRight' ? 1 : -1;
        const next = tabs[(index + offset + tabs.length) % tabs.length];
        next.focus();
        activateWorld(next.dataset.appWorld);
      });
    });

    const rail = root.querySelector('[data-app-screen-rail]');
    root.querySelectorAll('[data-app-scroll]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!rail) return;
        const direction = Number(button.dataset.appScroll) || 1;
        rail.scrollBy({ left: direction * rail.clientWidth * 0.82, behavior: 'smooth' });
      });
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-obp-app-root]').forEach(initAppPage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
